import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const kmDeVantagensTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#013765',
    },
    secondary: {
      main: '#fed41d',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#d24e1e',
    },
  },
};
